import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';

const CAN_SKIP_SUPPLIER_MATCHING = gql`
  query CanSkipSupplierMatching($campaignId: String!) {
    canSkipSupplierMatching(campaignId: $campaignId) {
      canSkipSupplierMatching
    }
  }
`;

const canSkipSupplierMatchingQuery = async ({ campaignId }) => {
  try {
    const { data } = await query({
      query: CAN_SKIP_SUPPLIER_MATCHING,
      variables: {
        campaignId,
      },
    });

    return data?.canSkipSupplierMatching?.canSkipSupplierMatching;
  } catch (error) {
    throw new Error('Failed to query can skip supplier matching', error);
  }
};

export default canSkipSupplierMatchingQuery;
